import React from 'react';
import { navigate, Link } from 'gatsby-link';
import { Menu, Button } from 'semantic-ui-react';
import TopNavMenuItem from './top-nav/TopNavMenuItem';
import logo from '../../assets/images/logo.svg';
import logoWhite from '../../assets/images/logo-white.svg';
import iconHamburger from '../../assets/images/icon-hamburger.svg';
import iconClose from '../../assets/images/icon-close.svg';
import TopBar from './top-nav/TopBar';
import MobileHeaderLinks from './mobile-menu/MobileHeaderLinks';
import TopNavSearch from './top-nav/TopNavSearch';
import SkipContent from './SkipContent';

const TopNavMenu = (props) => {
  const { menuItems, menuVisible, toggleMenu } = props;

  function handleHomeClick(e) {
    e.preventDefault();

    // If the current page is the homepage do toggleMenu otherwise link
    if (location.pathname === '/' && menuVisible) {
      toggleMenu();
    } else {
      navigate('/');
    }
  }

  return (
    <div className="top-nav__inner">
      <div className="top-nav__inner-row">
        <div className="top-nav__logo-grid  ">
          <SkipContent />
          <Link to="/" className="top-nav__logo-container" onClick={handleHomeClick} aria-label="homepage">
            <img className="top-nav__logo" src={menuVisible ? logoWhite : logo} alt="logo" />
          </Link>
        </div>
        <div className="top-nav__menus">
          <div className="top-nav__top-menu">
            <MobileHeaderLinks menuVisible={menuVisible} />
            <TopBar menuVisible={menuVisible} />
            <span className="top-nav__menu-toggle-container">
              <Button onClick={() => toggleMenu(!menuVisible)} className="top-nav__menu-toggle" role="button">
                <img className="top-nav__menu-toggle-icon" alt="menu" src={menuVisible ? iconClose : iconHamburger} />
              </Button>
            </span>
          </div>
          <div className="top-nav__bottom-menu">
            <Menu secondary>
              <Menu.Menu position="left" className="top-nav__menu-right">
                <div className="menu-item-wrapper">
                  {menuItems.map((item) => (
                    <TopNavMenuItem item={item} topLevel={true} key={item.databaseId} />
                  ))}
                </div>
              </Menu.Menu>
            </Menu>
          </div>
        </div>

        <div className="top-nav__mobile-search-wrapper">
          <TopNavSearch menuVisible={menuVisible} />
        </div>
      </div>
    </div>
  );
};

export default TopNavMenu;
